const boxShadowTheme = {
  shadow_1: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)',
};

export default boxShadowTheme;
